import { AxiosError } from 'axios'

type ErrorResponsePayload = ErrorResponse & { message?: string }

export const getApiErrorData = (
  error: unknown
): ErrorResponsePayload | undefined =>
  (error as AxiosError<ErrorResponse>).response?.data as
    | ErrorResponsePayload
    | undefined

export const getApiErrorMessage = (
  defaultMessages: string[],
  error: unknown
): string => {
  const data = getApiErrorData(error)
  const errorMessages = data?.errors || data?.message
  if (Array.isArray(errorMessages)) {
    return errorMessages.join(', ') || defaultMessages.join(', ')
  }
  return errorMessages || defaultMessages.join(', ')
}
